import { CSSProperties, FC, memo } from "react"
import styles from "./BattleField.module.scss"
import { IBattleFieldProps } from "./types"
import { BattleFieldCell } from "./ui/BattleFieldCell"

const BattleFieldComponent: FC<IBattleFieldProps> = ({
  cells,
  columns,
  onMove
}) => {
  if (cells.length === 0 || columns === 0) {
    return null
  }

  return (
    <div
      className={styles.BattleField}
      style={{ "--columns": columns } as CSSProperties}
    >
      {cells.map((cell) => (
        <BattleFieldCell key={cell.key} cell={cell} onMove={onMove} />
      ))}
    </div>
  )
}

export const BattleField = memo(BattleFieldComponent)
